/**
    companyName: '', // 分公司
    siteName: '', // 服务平台
    ledgerName: '', // 会计主体
    payChangeCashAmt: '', // 应收转押金金额
    businessProperty: '', // 业务类型
    contractName: '', // 合同名称
    suppliersCashType: '', // 押金类型
    toAmt: '', // 现汇金额
    penaltyAmt: '', // 罚扣款金额
    actualRefund: '', // 实际退款
    theReturnAmt: '', // 计划退款
    remark: '', // 备注
    currencyCode: '', // 币种
    createTime: '', // 创建日期
    budgetAmt: '', // 押金金额
    balanceAmt: '', // 余额
    statusText: '' // 合同状态
 *
 */
export default class DepositClass {
    constructor({ companyName, siteName, ledgerName, payChangeCashAmt, businessProperty,
        contractName, suppliersCashType, toAmt, penaltyAmt, actualRefund, theReturnAmt, remark, currencyCode, createTime, budgetAmt, balanceAmt, statusText }) {
        this.companyName = companyName || '';
        this.siteName = siteName || '';
        this.ledgerName = ledgerName || '';
        this.payChangeCashAmt = payChangeCashAmt || '';
        this.businessProperty = businessProperty || '';
        this.contractName = contractName || '';
        this.suppliersCashType = suppliersCashType || '';
        this.toAmt = toAmt;
        this.penaltyAmt = penaltyAmt;
        this.actualRefund = actualRefund;
        this.theReturnAmt = theReturnAmt;
        this.remark = remark || '';
        this.currencyCode = currencyCode || '';
        this.createTime = createTime || '';
        this.budgetAmt = budgetAmt || '';
        this.balanceAmt = balanceAmt || '';
        this.statusText = statusText || '';
    }
}

export function initOrgonaztion(data) {
    return new DepositClass(data);
}